import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 }
  };

  search() {
    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.delayValue);
  }
}

